import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class CrmTeamUser extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            crmTeamId: props.CrmTeamId,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/crm/team/user/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/crm/team/user/save", {
            id: this.state.id,
            crmTeamId: this.state.crmTeamId,
            mobile: this.state.data.record.mobile,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    } 
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش کاربر" : "افزودن کاربر جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                            <div className="container-fluid">
                            {this.renderSystemModuleModuleAccessMessage(this.state.innerStatus)}
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                            <label for="name" className="title1">شماره موبایل کاربر مورد نظر را وارد نمایید</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="11" />
                                            </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}